
export enum EShortcutsListenerContainer {
	CAPTIONS = 'captions',
	PHRASES = 'phrases',
}

export const setShortcutsListenerContainer = (
	container: EShortcutsListenerContainer,
) => {
	let w = window as any;
	w.shortcutsListenerContainer = container;
};

export const getShortcutsListenerContainer = (
) => {
	let w = window as any;
	return w.shortcutsListenerContainer || EShortcutsListenerContainer.CAPTIONS;
};

export const showShortcutsListenerContainer = (
) => {
	let type = getShortcutsListenerContainer();
	let container = document.querySelector(`.shortcuts-listener--${type}`) as HTMLElement;
	if (container) {
		container.classList.add('shortcuts-listener--active');
	}
};
